import { Control } from 'ol/control';

export class LayerSwitcherMetierControl extends Control {
  layers = [];
  overlay;
  visible = false;
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'M';
    button.title = 'Couches métiers';

    const element = document.createElement('div');
    element.className = 'ol-layer-switcher-metier ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.openPanel.bind(this), false);
  }

  openPanel() {
    if (!this.container) {
      this.createOverlayContainer();
    }
    this.container.classList.remove('non-visible');
  }

  closePanel() {
    this.container.classList.add('non-visible');
  }

  createOverlayContainer() {
    const container = document.createElement('div');
    this.getMap()
      .getLayers()
      .forEach((layer) => {
        if (layer.get('estCoucheMetier')) this.layers.push(layer);
      });

    const closeButton = document.createElement('div');
    closeButton.innerHTML = '✖';
    closeButton.classList.add('close-btn');
    closeButton.addEventListener('click', this.closePanel.bind(this));
    container.append(closeButton);

    this.layers.forEach((layer) => {
      const id = layer.get('id');
      const wrapper = document.createElement('div');
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.name = 'layer';
      checkbox.value = id;
      checkbox.id = id;
      checkbox.checked = layer.getVisible();

      checkbox.addEventListener('change', this.onCheckboxChange.bind(this));
      const label = document.createElement('label');
      label.textContent = layer.get('titre');
      label.for = id;
      wrapper.classList.add('layer');
      wrapper.append(checkbox);
      wrapper.append(label);
      container.append(wrapper);
    });
    container.classList.add('layer-switcher-container', 'non-visible');
    this.container = container;
    this.getMap().getViewport().append(this.container);
  }

  onCheckboxChange(event) {
    const id = event.target.value;
    const show = event.target.checked;
    this.layers.forEach((layer) => {
      // On se base sur l'index en tant qu'id.
      // id peut être soit un integer soit un uuid
      if (layer.get('id') === id || layer.get('id') === Number.parseInt(id)) {
        layer.setVisible(show);
      }
    });
  }
}
